import { apiFetch } from "./config.js";
/**
 * Lists Findings for the tabular/columnar review view: pick a set of
 * comparable orders (filtered by issue tag/forum/search) and pull one
 * field out of each into a spreadsheet-style grid.
 */
export async function listFindings(params = {}, signal) {
    return apiFetch("/findings", { query: { ...params }, signal });
}
